import type { APIResponse } from './base-fetch';
import { get } from './base-fetch';

export type ActivityStatus = APIResponse<'/api/v4/activity-statuses'>[number];

export const fetchActivityStatus = () =>
  get<ActivityStatus[]>('/v4/activity-statuses');
